<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import {
  orderMethods,
  orderComputed,
  orderStatusMethods,
  orderStatusComputed,
  orderOriginComputed,
  orderOriginMethods,
} from "@/state/helpers";
import Swal from "sweetalert2";

export default {
  components: { Layout, PageHeader },
  data() {
    return {
      dataLoaaded: false,
      totalRows: 0,
      title: "All Orders",
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortByOptions: [
        {
          value: "created_at",
          text: "Date",
        },
        {
          value: "id",
          text: "ID",
        },
        {
          value: "reference_num",
          text: "Order Number",
        },
        {
          value: "status",
          text: "Status",
        },
        {
          value: "origin",
          text: "Origin",
        },
      ],
      sortOrderOptions: [
        {
          value: "desc",
          text: "Desc",
        },
        {
          value: "asc",
          text: "Asc",
        },
      ],
      filter: {
        status: "",
        origin: "",
        q: "",
        sortBy: "created_at",
        sortOrder: "desc",
      },
      selectedOrders: [],
    };
  },
  computed: {
    ...orderComputed,
    ...orderStatusComputed,
    ...orderOriginComputed,
    filterApplied() {
      return (
        this.filter.status ||
        this.filter.origin ||
        this.filter.q ||
        this.filter.sortBy != "created_at" ||
        this.filter.sortOrder != "desc"
      );
    },
  },
  methods: {
    ...orderStatusMethods,
    ...orderOriginMethods,
    ...orderMethods,
    getOrders(page) {
      this.dataLoaaded = false;
      if (isNaN(page)) {
        page = 1;
      }
      this.currentPage = page;

      this.loadOrders({
        page: this.currentPage,
        perPage: this.perPage,
        origin: this.filter.origin,
        status: this.filter.status,
        q: this.filter.q,
        sortBy: this.filter.sortBy,
        sortOrder: this.filter.sortOrder,
      }).then(
        (ordersData) => {
          this.totalRows = ordersData.total;
          this.dataLoaaded = true;
        },
        (error) => {
          Swal.fire({
            icon: "error",
            title: "An error occured",
            text: JSON.stringify(error),
          });
        }
      );
    },

    onFiltered() {},

    archiveSelectedOrders() {
      if (this.selectedOrders.length) {
        try {
          for (const orderId of this.selectedOrders) {
            let orderData = { id: orderId, status_id: 6 };
            this.updatedOrder(orderData);
          }
          this.getOrders();
          this.selectedOrders.length = 0;
          Swal.fire({
            icon: "success",
            title: "Orders updated",
          });
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "An error occured",
            text: JSON.stringify(error),
          });
        }
      }
    },

    onCheckChange(event, order) {
      if (!event) {
        order.isSelected = false;
        this.selectedOrders = this.selectedOrders.filter((x) => x != order.id);
      } else {
        order.isSelected = true;
        this.selectedOrders.push(order.id);
      }
    },
    selectAllOrders(event) {
      let thisInstance = this;
      if (event) {
        thisInstance.selectedOrders = [];
        this.orders.forEach(function (order) {
          thisInstance.selectedOrders.push(order.id);
          order.isSelected = true;
        });
      } else {
        thisInstance.selectedOrders = [];
        this.orders.forEach(function (order) {
          order.isSelected = false;
        });
      }
    },
    onPageSizeChange() {
      this.getOrders();
    },
    resetFilters() {
      this.filter.status = "";
      this.filter.origin = "";
      this.filter.q = "";
      this.filter.sortBy = "created_at";
      this.filter.sortOrder = "desc";
      this.getOrders();
    },
  },
  mounted() {
    this.getOrders();
    this.loadOrderStatuses();
    this.loadOrderOrigins();
  },
};
</script>
    
<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-button :to="{ name: 'order-create' }">Create Order</b-button>
            <b-button
              class="ms-2"
              type="button"
              v-if="selectedOrders.length > 0"
              @click="archiveSelectedOrders"
            >
              <span>Archive Selected ({{ selectedOrders.length }})</span>
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="
        text-center
        d-flex
        align-items-center
        justify-content-center
        vh-100
        w-100
      "
      v-if="!dataLoaaded"
    >
      <b-spinner variant="primary"></b-spinner>
    </div>
    <div class="row" v-else>
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <!-- Search -->
              <div class="col-12 mb-4">
                <div class="row align-items-center">
                  <div class="col-2">
                    <label>Search</label>
                    <b-form-input
                      v-model="filter.q"
                      type="search"
                      placeholder="Ref. #"
                      class="form-control form-control"
                    ></b-form-input>
                  </div>
                  <div class="col-2">
                    <label>Status</label>
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="filter.status"
                      size="sm"
                      :options="orderStatuses"
                      value-field="id"
                      text-field="name"
                    >
                      <option slot="first" :value="''">-- All --</option>
                    </b-form-select>
                  </div>
                  <div class="col-2">
                    <label>Origin</label>
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="filter.origin"
                      size="sm"
                      :options="orderOrigins"
                      value-field="id"
                      text-field="name"
                    >
                      <option slot="first" :value="''">-- All --</option>
                    </b-form-select>
                  </div>
                  <div class="col-2">
                    <div>
                      <label for="orders-sort-column">Sort By</label>
                      <b-form-select
                        size="sm"
                        class="form-select form-select-sm"
                        id="orders-sort-column"
                        v-model="filter.sortBy"
                        :options="sortByOptions"
                      ></b-form-select>
                    </div>
                  </div>
                  <div class="col-2">
                    <div>
                      <label for="orders-sort-order">Sort Order</label>
                      <b-form-select
                        size="sm"
                        id="orders-sort-order"
                        class="form-select form-select-sm"
                        v-model="filter.sortOrder"
                        :options="sortOrderOptions"
                      ></b-form-select>
                    </div>
                  </div>
                  <div class="col-2 text-end">
                    <b-button
                      v-if="filterApplied"
                      type="button"
                      class="mt-4 me-2"
                      @click="resetFilters"
                    >
                      <span>Reset</span>
                    </b-button>
                    <b-button type="button" class="mt-4" @click="getOrders">
                      <span>Search</span>
                    </b-button>
                  </div>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col" style="width: 30px">
                      <b-form-checkbox
                        @change="selectAllOrders($event)"
                      ></b-form-checkbox>
                    </th>
                    <th scope="col">ID</th>
                    <th scope="col">Order Number</th>
                    <th scope="col">Customer</th>
                    <th scope="col">Status</th>
                    <th scope="col">Origin</th>
                    <th scope="col">Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="order in orders" :key="order.id">
                    <td>
                      <b-form-checkbox
                        :checked="order.isSelected == true"
                        @change="onCheckChange($event, order)"
                      ></b-form-checkbox>
                    </td>
                    <td>
                      <b-link
                        class="d-inline-block p-1 px-2 border border-rounded"
                        :to="{ name: 'order-edit', params: { id: order.id } }"
                      >
                        <span>Order#{{ order.id }}</span>
                      </b-link>
                    </td>
                    <td>{{ order.reference_num }}</td>
                    <td>
                      <b-link
                        class="d-inline-block p-1 px-2 border border-rounded"
                        :to="{
                          name: 'user-edit',
                          params: { id: order.customer.id },
                        }"
                      >
                        <span
                          v-if="
                            order.customer.first_name &&
                            order.customer.last_name
                          "
                        >
                          {{
                            order.customer.first_name +
                            " " +
                            order.customer.last_name
                          }}
                        </span>
                        <span v-else-if="order.customer.first_name">
                          {{ order.customer.first_name }}
                        </span>
                        <span v-else> Not Defined </span>
                      </b-link>
                    </td>
                    <td>
                      <span
                        class="d-inline-block border rounded px-2 py-1"
                        :class="{
                          'bg-warning text-white': order.status.id == 1, //Pending
                          'bg-info text-white': order.status.id == 2, //Approved
                          'bg-secondary text-white': order.status.id == 3, //In-review
                          'bg-danger text-white': order.status.id == 4, //Issue
                          'bg-success text-white': order.status.id == 5, //Completed
                          'text-dark': order.status.id == 6, //Archived
                        }"
                      >
                        {{ order.status.name }}
                      </span>
                    </td>
                    <td>{{ order.origin.name }}</td>
                    <td>
                      {{ moment(order.created_at).format("YYYY-MM-DD") }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row align-items-center justify-content-between">
              <div class="col">
                <div>
                  <label class="d-inline-flex align-items-center mb-0">
                    <span class="p-2">Show</span>
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      @change="onPageSizeChange"
                    ></b-form-select>
                    <span class="p-2">entries</span>
                  </label>
                </div>
              </div>
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      @change="getOrders"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>